import {atom} from 'jotai';
import {AiPromptActiveItem, AiVoteStateType} from '@/map/@types';

export const aiPromptActiveItemAtom = atom<AiPromptActiveItem>({open: false});

export const aiPromptStackAtom = atom<string[]>([]);

export const aiVoteListAtom = atom<{[key: string]: AiVoteStateType}>({});
